import axios from 'axios'

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_BACKEND : process.env.REACT_APP_LOCAL_BACKEND

export const post = async (options, data = null, headerOptions = null) => {
  return axios.post(options, data, headerOptions)
}
